var _path, _path2, _rect, _path3, _path4, _path5, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatchedIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4721 34.1185C21.9931 34.1973 21.5013 34.2383 21 34.2383C16.0294 34.2383 12 30.2088 12 25.2383C12 20.2677 16.0294 16.2383 21 16.2383C25.6326 16.2383 29.4477 19.7384 29.9451 24.2385C30.6217 24.2419 31.297 24.289 31.967 24.3793C31.5288 18.7057 26.7861 14.2383 21 14.2383C14.9249 14.2383 10 19.1631 10 25.2383C10 31.3134 14.9249 36.2383 21 36.2383C21.7095 36.2383 22.4033 36.1711 23.0754 36.0428C22.7923 35.4408 22.5869 34.7951 22.4721 34.1185Z",
    fill: "#522D56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8495 32.3467C40.4054 32.6119 40.9883 32.0249 40.6152 31.5347C38.1492 28.2951 34.2521 26.2039 29.8665 26.2039C25.481 26.2039 21.5839 28.295 19.1179 31.5346C18.7448 32.0247 19.3277 32.6118 19.8836 32.3465C21.3516 31.6462 22.9835 31.0961 24.7318 30.7287C24.4958 31.3417 24.3665 32.0077 24.3665 32.7039C24.3665 35.7414 26.8289 38.2039 29.8665 38.2039C32.9041 38.2039 35.3665 35.7414 35.3665 32.7039C35.3665 32.0077 35.2371 31.3417 35.0012 30.7287C36.7496 31.0961 38.3815 31.6463 39.8495 32.3467ZM33.3665 32.7039C33.3665 34.6369 31.7995 36.2039 29.8665 36.2039C27.9335 36.2039 26.3665 34.6369 26.3665 32.7039C26.3665 30.7709 27.9335 29.2039 29.8665 29.2039C31.7995 29.2039 33.3665 30.7709 33.3665 32.7039Z",
    fill: "#522D56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 10.2383,
    width: 6,
    height: 3,
    fill: "#522D56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 25.2383C19.5 26.0667 20.1716 26.7383 21 26.7383C21.8284 26.7383 22.5 26.0667 22.5 25.2383L19.5 25.2383ZM19.5 18.2383L19.5 25.2383L22.5 25.2383L22.5 18.2383L19.5 18.2383Z",
    fill: "#522D56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5032 17.8535C31.1191 17.2994 31.1692 16.351 30.6152 15.7351C30.0612 15.1192 29.1127 15.0691 28.4968 15.6231L30.5032 17.8535ZM27.9968 16.0729L26.8816 17.076L28.888 19.3064L30.0032 18.3032L27.9968 16.0729ZM28.4968 15.6231L27.9968 16.0729L30.0032 18.3032L30.5032 17.8535L28.4968 15.6231Z",
    fill: "#522D56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5607 15.6776C12.9749 15.0918 12.0251 15.0918 11.4393 15.6776C10.8536 16.2634 10.8536 17.2132 11.4393 17.7989L13.5607 15.6776ZM11.9393 18.2989L13 19.3596L15.1213 17.2383L14.0607 16.1776L11.9393 18.2989ZM11.4393 17.7989L11.9393 18.2989L14.0607 16.1776L13.5607 15.6776L11.4393 17.7989Z",
    fill: "#522D56"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 44.2383,
    x2: 44,
    y2: 44.2383,
    stroke: "#522D56",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchedIconSelected);
export default __webpack_public_path__ + "static/media/Watched_icon_selected.e75bb2b3ad8b896788e93ed0e48fb6c3.svg";
export { ForwardRef as ReactComponent };